import { gql } from '@apollo/client'

export default gql(`
    mutation($id: ID!, $channelId: ID) {
        deleteChannelConfigGroup(input: { id: $id }, channelId: $channelId )
        {
            id
        }
    }`
)
